import React, { PureComponent } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import ZonesMapPage from '../ZonesMapPage';
import NotFoundPage from '../NotFoundPage';
import ZonesEditPage from '../ZonesEditPage';

class App extends PureComponent {
  render () {
    return (
      <Router basename="/coverage-zones">
        <Switch>
          <Route exact path="/" component={ZonesMapPage} />
          <Route exact path="/:ownerId" component={ZonesEditPage} />
          <Route path="*" component={NotFoundPage} />
        </Switch>
      </Router>
    );
  }
}

export default App;
